import React, { useEffect } from "react";

import { useSocketAuthenticated } from "../../SocketContext";
import api from "../../../../services/api";

const SocketConnections = ({ setDuplicatedSessionModalOpen }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const { getSocket } = useSocketAuthenticated();



  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    const socket = getSocket();

    if (socket) {
      const handleWhatsappSession = (data) => {
        if (data.action === "disconnect" && `${api.defaults.headers.tenantId}` === `${data.tenantId}`) {
          setDuplicatedSessionModalOpen(true);
        }
      };

      socket.on("whatsappSession", handleWhatsappSession);

      return () => {
        socket.off("whatsappSession", handleWhatsappSession);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setDuplicatedSessionModalOpen]);



  //  ************
  //  ** Return **
  //  ************
  return (<></>);
};

export default SocketConnections;
